module.exports = __webpack_public_path__ + "static/img/loadin.06d9101.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pages/transitBearer/assets/loadin.gif
// module id = G2p7
// module chunks = 1